import React, {useEffect, useRef, useState} from "react"
import CustomerNavbar from "../../../../components/Navbars/CustomerNavbar"
import Shape from "../../../../components/Shape"
import {Button, Col, Container, Row} from "reactstrap"
import SimpleFooter from "../../../../components/Footers/SimpleFooter"
import {observer} from "mobx-react"
import Table, {Formatters} from '../../../../components/Table'
import {confirm, toast} from '../../../../components/Alert'
import {useAppDataStore} from "../../../../stores/appDataStore"
import EditModal from "./EditModal"
import {Buffer} from "buffer";
import images from "../../../../stores/images";
import {useNavigate} from "react-router";

const Categories = observer(() => {

  const [selectedData, setSelectedData] = useState(null)
  const [selectedRows, setSelectedRows] = useState([])
  const [productModalVisible, setProductModalVisible] = useState(false)
  const [data, setData] = useState([])
  const appDataStore = useAppDataStore()
  const navigate = useNavigate()
  const mainRef = useRef()

  useEffect(() => {
    refreshData()
  }, [])

  const columns = [
    {
      checkboxSelection: true,
      field: 'id',
      flex: 1,
      maxWidth: 50,
      minWidth: 50,
      headerName: '',
    },
    {
      field: 'imageUrl',
      flex: 1,
      maxWidth: 55,
      minWidth: 55,
      headerName: '',
      cellRenderer: Formatters.base64image
    },
    {
      field: 'position',
      headerName: '#',
      maxWidth: 60,
      minWidth: 60,
      flex: 1,
      cellRenderer: Formatters.number
    },
    {
      field: 'id',
      minWidth: 90,
      maxWidth: 90,
      headerName: 'ID',

    },
    {
      field: 'category',
      minWidth: 170,
      flex: 1,
      headerName: 'Categoria',
    },
    {
      field: 'description',
      flex: 1,
      headerName: 'Descripción',
      minWidth: 190,
    },
    {
      field: 'route',
      minWidth: 110,
      maxWidth: 110,
      headerName: 'Ruta',
    },
    {
      field: 'enabled',
      headerName: 'Habilitado',
      maxWidth: 100,
      minWidth: 80,
      flex: 1,
      cellRenderer: Formatters.boolean
    },
    {
      field: 'createdAt',
      headerName: 'Fecha creación',
      valueFormatter: Formatters.datetime
    },
    {
      field: '',
      maxWidth: 130,
      minWidth: 120,
      headerName: 'Opciones',
      cellRenderer: ({data}) => {
        return <div className="action-icons">
          <Button size={'sm'}
                  onClick={() => {
                    setSelectedData(data)
                    toggleProductModal()
                  }}>
            <i className="fa fa-pencil p-0"/>
          </Button>
          <Button size={"sm"} onClick={async () => {
            let confirmRes = await confirm(`se ${!data.enabled ? 'activará' : 'desactivará'} la categoria ${data.category}`)
            if (confirmRes && confirmRes.value) {
              await appDataStore.post('/backoffice/categories/edit', {
                id: data.id,
                enabled: !data.enabled
              })
              await refreshData()
            }
          }}><i className={`p-0 ni ni-button-power ${!data.enabled ? 'text-success' : 'text-danger'}`}/>
          </Button>
        </div>
      }
    }
  ]

  const buttons = [{
    label: 'Crear Categoría',
    icon: 'ni-circle-08',
    onClick: () => {
      setSelectedData(null)
      toggleProductModal()
    }
  }, {
    label: 'Productos',
    icon: 'ni-circle-08',
    onClick: () => {
      navigate('/customer/administration/products')
    }
  },
    {
      label: 'Desactivar',
      icon: 'ni-circle-08',
      onClick: async () => {
        let modalRes = await confirm(`se desactivaran <b>${selectedRows.length}</b> categorías. desea continuar?`)
        if (modalRes) {
          const id = selectedRows.reduce((previusValue, currentValue) => {
            previusValue.push(currentValue.id)
            return previusValue
          }, [])
          let res = await appDataStore.post('/backoffice/categories/disable', {id})
          if (res.result === 'error') return await toast(res.error)
          await refreshData()
        }
      }
    }
  ]

  const rowStyle = ({data}) => {
    let style = {}
    if (!data.enabled) style = {color: 'rgb(222,216,216)', fontStyle: 'italic'}
    return style
  }

  const refreshData = async () => {
    try {
      let {productCategories} = await appDataStore.get('/backoffice/categories')
      setData(productCategories)
    } catch (err) {
      console.log(err)
    }
  }

  const toggleProductModal = () => {
    setProductModalVisible(!productModalVisible)
  }
  const onSelectionChanged = ({api}) => {
    const selectedRows = api.getSelectedRows()
    setSelectedRows(selectedRows)
  }

  return (
    <>
      <CustomerNavbar/>
      <main ref={mainRef}>
        <section className="section section-shaped section-lg">
          <Shape/>
          <Container className="py-lg-md">
            <Row>
              <Col lg={12} md={12}>
                <EditModal
                  data={selectedData}
                  visible={productModalVisible}
                  toggle={toggleProductModal}
                  onSave={refreshData}
                />
                <Table
                  onRowDoubleClicked={({data}) => {
                    setSelectedData(data)
                    toggleProductModal()
                  }}
                  tableName={'Productos'}
                  cols={columns}
                  rows={data}
                  buttons={buttons}
                  rowStyle={rowStyle}
                  rowSelection={'multiple'}
                  onSelectionChanged={onSelectionChanged}
                />
              </Col>
            </Row>
          </Container>
        </section>
      </main>
      <SimpleFooter/>
    </>
  )
})

export default Categories
